import { ServiceAgreementStatus } from "@fs/enums/agreement-state.enum";
import { AgreementVisitModel } from "./visit.model";

export class AgreementRequestModel {
    ID: string;
    OriginWorkTicketPriceBookItemID: string;
    EquipmentIDs: string[];
    Visits: AgreementVisitModel[];
    Note: string;
    EffectiveDate: string;
    ExpirationDate: string;
    ModifyDate: string;

    constructor() {
        this.ID = "";
        this.OriginWorkTicketPriceBookItemID = "";
        this.EquipmentIDs = [];
        this.Visits = [];
        this.Note = "";
        this.EffectiveDate = "";
        this.ExpirationDate = "";
        this.ModifyDate = "";
    }
}

export class ServiceAgreementPatchRequestModel {
    ServiceAgreementStatus : ServiceAgreementStatus[];
    ID: string;
    CancelReasonID : string;
    CancelComment : string;
    CancellationReason : string;
    JobSiteID: string;
    ModifyDate: string;

    constructor() {
        this.ID = "";
        this.ServiceAgreementStatus = [];
        this.CancelReasonID = "";
        this.CancelComment = "";
        this.CancellationReason ="";
        this.JobSiteID = "";
        this.ModifyDate = "";
    }
}